(function ($) {
    // Close nav when inquiry opens
    $(document).on('click', '[data-open-modal="poptavka"]', function() {
        $('.nav__sidebar').removeClass('nav__sidebar--opened');
        $('.nav').removeClass('nav-bg');
        $('.nav__hamburger').removeClass('nav__hamburger--opened');
        $('.nav__hamburger-icon').removeClass('nav__hamburger-icon--opened');
        $('.home').removeClass('nav-overlay');
    });
})(jQuery);